import React, { useState, useEffect, useContext } from 'react'
import useApi from 'hooks/useApi'
import messages from './messages'
import { FormattedTime, FormattedDate, FormattedMessage, useIntl } from 'react-intl'
import { useKeyboardShortcut } from '@arnsbogroup/react-voicearchive/lib/hooks'
import { Accordion } from '@arnsbogroup/react-voicearchive'

const CommunicationPane = ({ match, location }) => {
  const { formatTime, formatDate, formatMessage } = useIntl()
  const [data] = useApi(`/ordercommunicationdisplay/ordercommunication.json?orderId=${match.params.orderId}`)
  const { tasks = [], coms } = data || {}

  return (
    <div className="p-4 space-y-8">
      { tasks.map((task) => (
        <div key={task.uid} className="p-2 space-y-2">
          <h1 className="text-sm font-medium">{ task.title } ({ task.taskType })</h1>
            
          { task.coms.map((com) => (
            <Accordion
              title={`${formatDate(new Date(com.crdate * 1000))} ${formatTime(new Date(com.crdate * 1000))} - ${com.subject}`}
              panelClassName="p-2 text-sm"
              className="p-2 text-sm"
            >
              <p dangerouslySetInnerHTML={{ __html: com.msg.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2') }} />
            </Accordion>
          )) }
        </div>
      )) }
    </div>
  )
}

export default CommunicationPane
